Object.defineProperty(exports, '__esModule', {
    value: true
});
var INFINITE_PREFIX = '$inf$';
exports.INFINITE_PREFIX = INFINITE_PREFIX;
